// extracted by mini-css-extract-plugin
export var container = "_6i-0";
export var infoButton = "_6i-1";
export var label = "_6i-3";
export var labelExpanded = "_6i-4";
export var price = "_6i-5";
export var priceExpanded = "_6i-6";
export var title = "_6i-2";